import React, { useContext, useEffect, useState } from 'react'
import { mapData } from '../../../../product/common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthContext from '../../../../product/context/auth/authContext'
import Popup from '../../organisms/Popup'
import commonContext from '../../../../custom/context/common/commonContext'
import AlertContext from '../../../../product/context/alert/alertContext'

function AddMoney(props) {
    const { user } = useContext(AuthContext)
    const { setAlert } = useContext(AlertContext)
    const { createTransfer, dwollaTranseResponse, clearTransResponse } = useContext(commonContext)
    const [loading, setLoading] = useState(false)

    const validationArray = [
        Yup.object({
            amount: Yup.number().required('Required!'),
        }),
    ]
    const ssnFormik = useFormik({
        initialValues: {
            amount: '',
        },
        validationSchema: validationArray[0],
        onSubmit: (values) => {
            setLoading(true)
            let payload = {
                amount: { value: values.amount, currency: 'USD' },
                links: {
                    source: { href: props.fromSource._links.self.href },
                    destination: { href: props.toSource._links.self.href },
                },
                type: 'Bank To Wallet',
            }
            createTransfer(payload)
        },
    })

    useEffect(() => {
        if (dwollaTranseResponse && dwollaTranseResponse.status) {
            setAlert('Request sent successfully', 'success')
            props.function(false, 'add_money', null)
            props.handleResponse(false, 'add_money', null)
            clearTransResponse()
            setLoading(false)
        }
    }, [dwollaTranseResponse])

    const ssnField = [
        {
            label: 'Amount',
            name: 'amount',
            placeholder: 'Enter amount',
            class: `col-12`,
            formik: ssnFormik,
            type: 'number',
            upperLabel: true,
        },
    ]

    return (
        <>
            {props.data.popup && (
                <Popup
                    open={props.data.popup && props.data.status === 'add_money'}
                    cstmModalClass="kycAmlModal"
                    size="sm"
                    handleClose={() => props.function(false, 'add_money', null)}
                    modaltitle="Add Money"
                >
                    <>
                        <form onSubmit={ssnFormik.handleSubmit} autoComplete="nofill">
                            <div className="row">{Object.values(mapData(ssnField))}</div>
                            <div className="row">
                                <div className="col-12">
                                    <PrimaryButton
                                        disabled={loading}
                                        btnSize="large"
                                        type="submit"
                                        label={loading ? '...' : 'Submit'}
                                    />
                                </div>
                            </div>
                        </form>
                    </>
                </Popup>
            )}
        </>
    )
}

export default AddMoney
